<template>
  <div class='c-mypagetop'>
    {{$route.params.userid}}
    <div class="c-mypagetop--info">
      <h2>お知らせ</h2>
      <ul v-if="this.infoList !== null">
        <li v-for="(item, index) in infoList" :key="index">
          <span>{{isDateFormated(item.publishedAt)}}</span>
          <span class="left-margin">{{item.message}}</span>
       </li>
      </ul>
    </div>

    <withdraw-mailer class="c-mailer-link"/>

  </div>
</template>

<script>
import MixinAPI from '@/plugins/mixin-api';
import dayjs from 'dayjs';
import WithdrawMailer from '@/components/common/WithdrawMailer';
import { getMe } from '@/api/mypage';

dayjs.locale('ja');

export default {
  name: 'MyPageTop',
  components: {
    WithdrawMailer,
  },
  data() {
    return {
      infoList: null,
    };
  },
  mixins: [MixinAPI],
  async created() {
    getMe();
    const r = await this.getMypageInfoList();
    this.infoList = r.data.contents;
    // Footer表示フラグ更新
    await this.$store.commit('setFooterDisplayFlag');
  },
  methods: {
    isDateFormated(val) {
      return dayjs(val).format('YYYY年MM月DD日');
    },
  },

};
</script>

<style scoped lang='scss'>
.c-mypagetop {
  min-height: 420px;
  padding: 0 60px;

  &--info{
    border: 1px solid #CCCCCC;
    background-color: white;
    border-radius: 14px;
    margin: 14px 0;
    padding: 20px;
    height: 320px;

    ul {
      overflow: auto;
      height: calc(100% - 40px);
      li {
        line-height: 1.4em;;
        font-size: 14px;
        margin-bottom: 8px;
        display: flex;

        span {
          word-break: break-all;
        }

      }
    }
  }

  h2 {
    text-align: left;
    line-height:1em;
    margin:0;
    margin-bottom: 20px;
    font-size: 18px;
    font-weight: bold;
  }
}

.c-mailer-link {
  text-align: right;
}

.left-margin {
  margin-left: 10px;
}

@media (max-width: 639px) {
  .c-mypagetop {
    padding: 0 6px;
  }
}
</style>
